export default function AcademyAdminiPhoneBottom({ style }) {
  return (
    <svg
      width="375"
      height="34"
      viewBox="0 0 375 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style || {}}
    >
      <path
        d="M120 23.5C120 22.1193 121.119 21 122.5 21H252.5C253.881 21 255 22.1193 255 23.5C255 24.8807 253.881 26 252.5 26H122.5C121.119 26 120 24.8807 120 23.5Z"
        fill="black"
      />
    </svg>
  );
}
